declare const gtag: any


export function track(event: string, properties: object = {}) {
  gtag('event', event, properties)
}


// WEBPACK FOOTER //
// ./src/service/event.ts